var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkerBlud({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 49,
    viewBox: "0 0 39 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2021 0.199219C29.6956 0.199219 38.2021 8.40462 38.2021 18.5265C38.2021 19.762 38.0754 20.9689 37.8338 22.1359C36.1568 34.3257 19.302 48.1992 19.302 48.1992C19.302 48.1992 4.95839 36.3927 1.41865 24.9931C0.632369 22.9822 0.202148 20.8028 0.202148 18.5265C0.202148 8.40462 8.70874 0.199219 19.2021 0.199219Z",
    fill: "#003056"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_25133_63358",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 10,
    width: 21,
    height: 18
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5759 12.3782H26.8284C27.4276 12.3782 27.9179 11.8879 27.9179 11.2887C27.9179 10.6895 27.4276 10.1992 26.8284 10.1992H11.5759C10.9767 10.1992 10.4864 10.6895 10.4864 11.2887C10.4864 11.8879 10.9767 12.3782 11.5759 12.3782ZM28.0922 14.3392C27.9942 13.838 27.5475 13.4676 27.0245 13.4676H11.3798C10.8568 13.4676 10.4101 13.838 10.3121 14.3392L9.22261 19.7865C9.09188 20.462 9.60393 21.0939 10.2903 21.0939H10.4864V26.5413C10.4864 27.1405 10.9767 27.6307 11.5759 27.6307H20.2916C20.8908 27.6307 21.3811 27.1405 21.3811 26.5413V21.0939H25.739V26.5413C25.739 27.1405 26.2292 27.6307 26.8284 27.6307C27.4276 27.6307 27.9179 27.1405 27.9179 26.5413V21.0939H28.114C28.8004 21.0939 29.3124 20.462 29.1817 19.7865L28.0922 14.3392ZM19.2021 25.4518H12.6653V21.0939H19.2021V25.4518Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_25133_63358)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.20215,
    y: 9.19922,
    width: 21.7143,
    height: 20.9455,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerBlud);
export default __webpack_public_path__ + "static/media/MarkerBlud.089a7fd15c53fcb6b1ca69edf9f1861c.svg";
export { ForwardRef as ReactComponent };